export default {
  name: 'yiyang',
  adcode: '430900',
  mapName: '益阳市',
  geoJsonPath: 'hunanmap/430900.json',
  backgroundImage: {
    png: '益阳市_430900.png',
    webp: '益阳市_430900.webp'
  },
  echartsMapStyle: {
    width: '907px',
    height: '663px',
    marginTop: 'auto',
    marginBottom: '82px',
  },
  imageSize: {
    width: 4186,
    height: 3060
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.35, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.001,  // X轴偏移百分比
      y: 0.001  // Y轴偏移百分比
    }
  },
  // 区县列表（益阳市）
  districts: ['益阳市区', '南县', '桃江县', '安化县', '沅江市'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（兜底）
    '益阳市区': [112.285, 28.563],
    '益阳市': [112.355, 28.553],
    '南县': [112.326, 29.254],
    '桃江县': [111.869, 28.489],
    '安化县': [111.273, 28.387],
    '沅江市': [112.455, 28.985]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    if (s === '益阳市') return '益阳市区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '资阳区': '430902',
    '赫山区': '430903',
    '南县': '430921',
    '桃江县': '430922',
    '安化县': '430923',
    '沅江市': '430981'
  }
}